import * as React from "react";
import * as MatStyled from "@mui/material/styles";
import { device } from "src/styles/device";
import styled from "styled-components";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { getUserInfo } from "src/api/auth";
import { checkNotEmpty } from "src/common";
import useDeviceSize from "src/hooks/useDeviceSize";
import { useAuth } from "src/hooks/useAuth";

const Container = styled.div`
  padding: 50px 175px;
  @media ${device.desktop} {
    padding: 50px 75px;
  }
  @media ${device.laptop} {
    padding: 50px 50px;
  }
  @media ${device.tabletL} {
    padding: 50px 50px;
  }
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));
export default function Auth({ open }) {
  let { token } = useParams();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("redirect_to");
  const [deviceWidth] = useDeviceSize();

  const { setToken } = useAuth();

  React.useEffect(() => {
    if (token) {
      setToken(token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  React.useEffect(() => {
    (async () => {
      try {
        const data = await getUserInfo();

        if (deviceWidth > 0) {
          if (deviceWidth <= 835) {
            if (data?.role_id === 3) navigate(`/seller-order/list`);
            else navigate(`/sale-quotation/list`);
          } else if (checkNotEmpty(redirectTo)) navigate(`/${redirectTo}/list`);
          else navigate("/dashboard-sales-performance");
        }
      } catch (error) {
        console.log("auth error", error);
        // localStorage.clear();
        // window.location.assign("https://xsurface.com");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, deviceWidth]);

  return (
    <Main sx={{ width: "100%", marginTop: "75px" }} open={open}>
      <Container></Container>
    </Main>
  );
}
